import React from "react";
import PropTypes from "prop-types";

export default function ModalFooter({ children }) {
  return <div className="mt-5 flex justify-end sm:flex w-full">{children}</div>;
}

ModalFooter.propTypes = {
  children: PropTypes.any,
};
